import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useYoutubeAnalyticsCountriesCategoriesQuery } from '@anytag/graphql';
import { useTranslateOptions, useTranslateCountryOptions } from '@anytag/shared-hooks';

export const useYoutubeAnalyticsCountriesCategoriesOptions = (options?: QueryHookOptions<Query>) => {
  const { data, loading } = useYoutubeAnalyticsCountriesCategoriesQuery({ fetchPolicy: 'cache-first', ...options });

  const response = data?.youtubeAnalyticsCountriesCategories;
  const allCountryOptions = useTranslateCountryOptions(getSelectOptions(response?.countries || []));
  const allCategoryOptions = useTranslateOptions(getSelectOptions(response?.categories || []));

  return {
    loading,
    allCountryOptions,
    allCategoryOptions,
    date: response?.date
  };
};
